import { render, staticRenderFns } from "./order-info.vue?vue&type=template&id=679ac5e4&scoped=true"
import script from "./order-info.vue?vue&type=script&lang=js"
export * from "./order-info.vue?vue&type=script&lang=js"
import style0 from "./order-info.vue?vue&type=style&index=0&id=679ac5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ac5e4",
  null
  
)

export default component.exports